module.exports = __webpack_public_path__ + "img/SU1F10.6b888ae6.jpg";